<script setup lang="ts">const rawHtml = __MACROS_toRef(__props, "html");

import { toRef as __MACROS_toRef } from "vue";
import { mergeDefaults as __MACROS_mergeDefaults } from "vue";

defineProps(__MACROS_mergeDefaults({
  as: null,
  html: null
}, { as: 'div', }))

</script>

<template>
  <component
    :is="as"
    v-dompurify-html="rawHtml"
  />
</template>
